import React, { useState, useEffect } from "react";
import "../../../assets/FlpConsent/scss/style.scss";
import "../../../assets/FlpConsent/scss/custom.scss";
import "../../../assets/FlpConsent/scss/questionnaire.scss";
import "../../../assets/FlpConsent/scss/personaldetails.scss";

import { useHistory } from "react-router-dom";
import bg_money_sml from "../../../assets/FlpConsent/img/bg-money-sml.png";
import logo from "../../../assets/FlpConsent/img/logo.png";
import charterhouseclaims from "../../../assets/FlpConsent/img/charterhouseclaims.95e1eeee.png";
import pdf_img from "../../../assets/FlpConsent/img/pdf.svg";
import ssl from "../../../assets/FlpConsent/img/ssl.png";
import loader_img from "../../../assets/img/loader-review2.svg";
import { useFollowupUserQuestions } from "../../../Hooks/useFollowupUserQuestions";

import "bootstrap-icons/font/bootstrap-icons.css";

import LoaNew from "../../../Components/Includes/Layouts/MOCK_OD/LoaNew";
import ChAuthNew from "../../../Components/Includes/Layouts/MOCK_OD/ChAuthNew";
import ChWelcomePcp from "../../../Components/Includes/Layouts/MOCK_OD/ChWelcomePcp";
import TermsAndCondtion from "../../../Components/Includes/Layouts/MOCK_OD/TermsAndCondtion";
import Privacypolicy from "../../../Components/Includes/Layouts/MOCK_OD/Privacypolicy";
import { usePageLoad } from "../../../Hooks/usePageLoad";
import { getQueryString } from "../../../Utility/QueryString";

const FlpconsentDetails = ({
  showConsent,
  backClick,
  allFollowupData,
  currentUuid,
}) => {
  const { savePageLoad, calledOnce } = usePageLoad();
  const queryString = getQueryString() ?? window.location.search.substring(1);

  const history = useHistory();
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  // Dropdown for documents list
  const [isOpen, setIsOpen] = useState(false);
  const toggleDocuments = () => {
    setIsOpen(!isOpen);
  };

  // Individual modal states
  const [loa, setLoa] = useState(false);
  const [chAuth, setChAuth] = useState(false);
  const [chWelcomePcp, setChWelcomePcp] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);

  const trackVisitStatus_de = async (uuid, page_name, source) => {

    if (!uuid || !source) return;

    const data = {
      uuid,
      page_name,
      status: "visited",
      source,
    };

    await savePageLoad(
      uuid,
      data,
      "visited_status",
      "flp_consents",
      queryString
    );
  };

  useEffect(() => {
    const runTracking = async () => {
      if (showConsent === "show") {
        await trackVisitStatus_de(
          currentUuid,
          "flp_consent_question_detail_page_visited",
          allFollowupData?.atp_sub6
        );
      }
    };

    runTracking(); // 👈 this is critical – without this, nothing happens
  }, [showConsent, currentUuid, allFollowupData]);

  const handleOptionChange = (value) => {
    let question_data = {
      question_id: 118,
      option_id: value,
      answer_text: null,
      input_answer: null,
    };
    // visited
    let visited_answer = "nothing";
    if (value == "326") {
      visited_answer = "flp_consent_clicked_answer_yes";
    } else if (value == "327") {
      visited_answer = "flp_consent_clicked_answer_no";
    }

    (async () => {
      await trackVisitStatus_de(
        currentUuid,
        visited_answer,
        allFollowupData?.atp_sub6
      );
    })();

    storeQuestionnire(question_data);
    history.push("/thankyouPageFlp?uuid=" + currentUuid);
  };

  const storeQuestionnire = async (question_data) => {
    const response = await saveFollowupUserQuestions(
      question_data,
      allFollowupData,
      "followup_question_store"
    );
  };

  return (
    <>
      <div className={showConsent}>
        <section className="banner  parallax-container">
          <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
            <img src={bg_money_sml} alt="" />
          </div>
          <div className="container">
            <div>
              <div className="brand">
                <div className="logo pt-3">
                  <img src={logo} height={60} alt="" />
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div className="container pt-5 px-lg-2 px-md-2 px-sm-0 px-0  ">
            <div className="inner-section   ">
              <div className="d-lg-none d-md-none d-sm-block d-block sub-text mb-4 slide-up-now">
                <p>
                  While reviewing your case, we’ve identified a potential
                  opportunity to pursue further claims for mis-sold car
                  finance.&nbsp;
                </p>
              </div>
              <div className="body-questionnaire mb-4">
                <div className="inner rounded-4">
                  <div className="swipers-slide">
                    <h2 className="qs-title">
                      While reviewing your case, we’ve identified a potential
                      opportunity to pursue further claims for mis-sold car
                      finance.
                    </h2>
                    <p>
                      We believe our partner, Charterhouse Claims, is well
                      suited to support you with this claim for{" "}
                      <span style={{ background: "yellow" }}>
                        an opportunity to earn £1,000's* or more per car loan!
                      </span>{" "}
                      . If you would like, we may refer your details to them.
                    </p>
                    <ul className="list-content   mt-lg-0 mt-2 mb-0 ms-0">
                      <li>This will not reduce your compensation</li>
                      <li>
                        You are free to choose a different solicitor, you can
                        make a complaint directly with the lender, or you can
                        refer your claim to the Financial Ombudsman Service
                        (FOS) yourself for free.
                      </li>
                      <li>
                        Charterhouse claim’s ability to act independently will
                        not be compromised
                      </li>
                      <li>
                        We may receive a
                        <span className="fw-semibold">
                          &nbsp;<u>referral-fee</u>
                        </span>
                      </li>
                    </ul>
                    <ul className="btn-option optinal-items two-options     ">
                      <li>
                        <div className=" option_but ">
                          <input
                            type="radio"
                            id="overdraft"
                            value={326}
                            name="consentyes"
                            onChange={(e) => handleOptionChange(e.target.value)}
                          />
                          <label
                            htmlFor="overdraft"
                            className=" pulse2 align-items-center justify-content-center  btn-next"
                          >
                            <div> Yes, Please Pursue</div>
                          </label>
                        </div>
                      </li>
                      <li>
                        <div className=" option_but  btn-next">
                          <input
                            type="radio"
                            id="overdraft2"
                            value={327}
                            name="consentno"
                            onChange={(e) => handleOptionChange(e.target.value)}
                          />
                          <label
                            htmlFor="overdraft2"
                            className="text-center justify-content-center"
                          >
                            <div> No, Thank You</div>
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="text-center my-2 mb-4">
                    <img height={70} src={charterhouseclaims} alt="" />
                  </div>
                  <p className="text-center view-document">
                    <button id="view-document" onClick={toggleDocuments}>
                      View Charterhouse Claims Documents
                    </button>
                  </p>

                  <div
                    className={`p-4 bg-white rounded-4 mb-3 box-documents ${
                      isOpen ? "is-open" : ""
                    }`}
                  >
                    <ul className="pdf-list m-0 p-0 text-start">
                      <li>
                        <button onClick={() => setLoa(true)}>
                          <img height={30} src={pdf_img} alt="" /> Letter of
                          Authority
                        </button>
                      </li>
                      <li>
                        <button onClick={() => setChAuth(true)}>
                          <img height={30} src={pdf_img} alt="" /> Certificate
                          of Authenticity
                        </button>
                      </li>
                      <li>
                        <button onClick={() => setPrivacyPolicy(true)}>
                          <img height={30} src={pdf_img} alt="" /> Privacy
                          Policy
                        </button>
                      </li>
                      <li>
                        <button onClick={() => setChWelcomePcp(true)}>
                          <img height={30} src={pdf_img} alt="" /> Welcome
                          Letter
                        </button>
                      </li>
                      <li>
                        <button onClick={() => setTermsAndConditions(true)}>
                          <img height={30} src={pdf_img} alt="" /> Terms and
                          Conditions
                        </button>
                      </li>
                    </ul>
                  </div>
                  <p className="text-center below-text">
                    *An FCA investigation revealed that the average customer on
                    a £10,000 PCP agreement over four years has been overcharged
                    by more than £1,100 (
                    <a href="https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/"
                       target="_blank"
                       rel="noopener noreferrer"
                    >
                      https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/
                    </a>{" "}
                    )
                  </p>
                  <div className="mt-2 mb-3  slide-up-now">
                    <div className="mt-2 mb-4 text-center">
                      <div>
                        {" "}
                        <button
                          className="back-btn mainbckBtn"
                          onClick={() => backClick()}
                        >
                          <i className="bi bi-chevron-left" /> Back
                        </button>{" "}
                      </div>
                      <div className="mt-5">
                        <img height={30} src={ssl} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* Render Modals conditionally */}
      {loa && <LoaNew close={() => setLoa(false)} />}
      {chAuth && <ChAuthNew close={() => setChAuth(false)} />}
      {chWelcomePcp && <ChWelcomePcp close={() => setChWelcomePcp(false)} />}
      {termsAndConditions && (
        <TermsAndCondtion close={() => setTermsAndConditions(false)} />
      )}
      {privacyPolicy && <Privacypolicy close={() => setPrivacyPolicy(false)} />}
    </>
  );
};
export default FlpconsentDetails;
